<template>

  <div :class="modalClass"><b-container>

    <b-row><b-col>
      <div v-if="jobType=='input'">
        <br/><h2>IoTキット映像画面</h2><br/>
      </div>
    </b-col></b-row>

    <b-row><b-col>
    <div v-if="jobType=='predict'"><strong>IoTキット映像画面</strong></div>
    <div class="img_container">
      <img  class="img-cls" :src="imgSrc"/>
      <div class="relativecls inlineblkcls canvas28div"><canvas id="draw_canvas28" width="28" height="28" class="canvas28"></canvas>
        <div class="aicanvas-word"><strong>AI利用<br/>サイズ</strong></div>
      </div>
      <canvas id="draw_canvas" width="176" height="144" v-show="false"></canvas>
    </div>
    </b-col><b-col v-show="renzoku">
      <div id="canvas_cont" class="canvas-cont-cls relativecls"></div>
      <div class="canvas-cont-word">連続取得した画像表示：{{renzokuCount}}枚</div>
    </b-col></b-row>

    <b-row><b-col>
    <div id="answer" v-if="jobType=='input'" class="btngwidth">
      <br/>
      <b-button variant="outline-primary" class="btnw" @click="cancelImg">Cancel</b-button>
      <b-button id="startbtn1" variant="outline-primary" class="btnw" @click="wsConJob">{{startBtnName}}</b-button>
      <div class="inlineblkcls relativecls">
        <b-button variant="outline-primary" class="btnw" @click="setImg">Set</b-button>
        <div class="renCheck">
          <b-form-checkbox v-model="renzoku" size="sm" name="check-button" switch switch-variant="outline-primary" v-on:change="renChkChange">
          連続<b>{{renzokuWord}}</b><span class="verysFont">(秒)</span>
          </b-form-checkbox>
          <b-form-spinbutton v-model="renSpinval" min="0.2" max="100" step="0.2" size="sm" inline :disabled="renSpinDisabled"></b-form-spinbutton>
        </div>
        <div class="getRenzokuCls">
        <b-button variant="outline-primary" class="btnw" v-if="renzoku" @click="getRenzoku">{{getRenzokuBtn}}</b-button>
        </div>
      </div>
      <br/>
    </div></b-col></b-row>
    <b-row><b-col><div>
      <div id="message_window" class="margintop">
        <div class="dispmes inlinecls">{{dispMessage}}</div>
        <b-button id="startbtn2" variant="outline-primary" class="inlinecls" v-if="jobType=='predict'" @click="wsConnect">Start</b-button>
        <b-button id="stopbtn" variant="outline-primary" class="inlinecls" v-if="jobType=='predict'" @click="wsDisconnect">Stop</b-button>
      </div>
      <div v-if="jobType=='input'"><br/></div>
    </div>
    </b-col></b-row>

  </b-container></div>

</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'inmodalpc',
  props: {
    jobType: { type: String, default: 'input' }
  },
  data () {
    return {
      m_in: 0,
      m_img: 0,
      dispMessage: 'IoTキットの電源を入れて「Start」して下さい。',
      webskt: null,
      wsFlag: false,
      width: 176,
      height: 144,
      canvas: null,
      ctx: null,
      canvas28: null,
      ctx28: null,
      imageData: null,
      imgSrc: null,
      reconTimer: null,
      renzokuTimer: null,
      renzoku: false,
      renSpinval: 0.6,
      renzokuCount: 0,
      renzokuWord: 'OFF',
      renSpinDisabled: false,
      getRenzokuFlag: false
    }
  },
  computed: {
    ...mapState([ 'setKits', 'setModals' ]),
    modalClass () {
      if (this.renzoku) {
        return 'modal-contentmax modal-pad2'
      } else {
        if (this.jobType === 'predict') {
          return 'widthmax'
        } else {
          return 'modal-content modalLightGray modal-pad1'
        }
      }
    },
    getRenzokuBtn () {
      if (this.getRenzokuFlag) {
        return '停止'
      } else {
        return '連続取得'
      }
    },
    startBtnName () {
      if (this.wsFlag) {
        return 'Stop'
      } else {
        return 'Start'
      }
    }
  },
  methods: {
    renChkChange () {
      if (this.renzoku) {
        this.renzokuWord = 'OFF'
        this.renSpinDisabled = true
        this.dispMessage = 'IoTキットの電源を入れて「Start」して下さい。'
      } else {
        this.renzokuWord = 'ON'
        this.renSpinDisabled = false
        this.dispMessage = '「Start」後に「連続取得」で画像を取得できます。取得画像を確認し「Set」して下さい。'
      }
    },
    update_message: function (str) {
      this.dispMessage = str
    },
    // --------------------WebSocket関連--------------------
    wsConJob () {
      if (this.wsFlag) {
        this.wsDisconnect()
      } else {
        this.wsConnect()
      }
    },
    wsConnect: function () {
      var ref = this // CallBack時には代入
      this.wsFlag = true
      if (this.webskt == null) {
        this.webskt = new WebSocket('ws://' + this.setKits.kitip + ':81')
        this.webskt.binaryType = 'arraybuffer'
        this.webskt.onopen = function (evt) { ref.onOpenFunc(evt) }
        this.webskt.onclose = function (evt) { ref.onCloseFunc(evt) }
        this.webskt.onmessage = function (evt) { ref.onMessageFunc(evt) }
        this.webskt.onerror = function (evt) { ref.onErrorFunc(evt) }
      }
    },
    wsDisconnect: function () {
      this.wsFlag = false
      clearInterval(this.renzokuTimer)
      clearInterval(this.reconTimer)
      if (this.webskt != null) {
        this.webskt.close()
        this.webskt = null
      }
      this.update_message('通信停止')
    },
    onOpenFunc: function (evt) {
      this.update_message('通信中')
    },
    onCloseFunc: function (evt) {
      this.update_message('通信停止')
      this.wsClose()
    },
    onErrorFunc: function (evt) {
      this.update_message('Err:' + evt.data)
      this.wsClose()
    },
    onMessageFunc: function (evt) {
      var data = evt.data
      if (typeof data === 'string') {
        this.update_message(data)
      } else if (data instanceof ArrayBuffer) {
        this.drawLine(evt.data)
      } else if (data instanceof Blob) {
        this.update_message('Blob data received')
      }
    },
    wsClose: function () {
      if (this.webskt != null) {
        this.webskt.close()
        this.webskt = null
      }
      if (this.wsFlag) {
        this.reconTimer = setTimeout(this.wsConnect, 500)
      }
    },
    drawLine: function (data) {
      var buf = new Uint16Array(data)
      var pixels = this.imageData.data
      // console.log('pixels:' + pixels.byteLength + ':' + buf.length) // 704,25344
      for (var y = 0; y < (buf.length) / this.width; y += 1) {
        var base = 0
        for (var x = 0; x < this.width; x += 1) {
          var c = x + y * this.width
          pixels[base + 0] = (buf[c] & 0xf800) >> 8 | (buf[c] & 0xe000) >> 13
          pixels[base + 1] = (buf[c] & 0x07e0) >> 3 | (buf[c] & 0x0600) >> 9
          pixels[base + 2] = (buf[c] & 0x001f) << 3 | (buf[c] & 0x001c) >> 2
          pixels[base + 3] = 255
          base += 4
        }
        this.ctx.putImageData(this.imageData, 0, y)
      }
      this.imgSrc = this.canvas.toDataURL('image/jpeg')
      this.ctx28.drawImage(this.canvas, 0, 0, this.canvas28.width, this.canvas28.height)
      // if (y === height) fps += 1 // fps(freme per second)をカウントする場合に利用
    },
    // --------------------WebSocket関連--------------------
    setImg: function () {
      this.wsDisconnect()
      this.dispMessage = '処理中です。しばらくお待ち下さい...'
      if (this.renzoku) {
        for (var i = 1; i <= this.renzokuCount; i++) {
          const gid = 'gcanvas' + String(i)
          const gcanvas = document.getElementById(gid)
          this.$store.dispatch('setImage', {
            s_in: this.m_in,
            s_img: i,
            s_data: gcanvas.toDataURL()
          })
        }
      } else {
        // const img = ctx.drawImage(canvas, 0, 0, inputWidth, inputHeight) // 画像をリサイズ
        // const imgRgba = this.ctx.getImageData(0, 0, this.width, this.hight).data // RGBAデータになる
        // Set Vuex
        // 画像の各ピクセルをグレースケールに変換する
        var pixels = this.ctx28.getImageData(0, 0, this.canvas28.width, this.canvas28.height)
        for (var y = 0; y < pixels.height; y++) {
          for (var x = 0; x < pixels.width; x++) {
            var j = (y * 4) * pixels.width + x * 4
            var rgb = parseInt((pixels.data[j] + pixels.data[j + 1] + pixels.data[j + 2]) / 3, 10)
            pixels.data[j] = rgb
            pixels.data[j + 1] = rgb
            pixels.data[j + 2] = rgb
          }
        }
        this.ctx28.putImageData(pixels, 0, 0)
        this.$store.dispatch('setImage', {
          s_in: this.m_in,
          s_img: this.m_img,
          s_data: this.canvas28.toDataURL()
        })
        /* this.$store.dispatch('setAidata', {
          s_in: this.m_in,
          s_img: this.m_img,
          s_aid: this.ctx28.getImageData(0, 0, this.canvas28.width, this.canvas28.height).data
        }) */
      }
      // 画面を閉じる
      this.cancelImg()
    },
    getRenzoku () {
      this.getRenzokuFlag = !this.getRenzokuFlag
      // 映像を連続受信
      if (this.getRenzokuFlag) {
        // 開始時の初期処理
        this.renzokuCount = 0
        while (this.canvascont.lastChild) {
          this.canvascont.removeChild(this.canvascont.lastChild)
        }
        // Canvas保存処理
        this.getRenzokuCanvas()
      // 映像取得をSTOP
      } else {
        clearInterval(this.renzokuTimer)
      }
    },
    getRenzokuCanvas () {
      const gcanvas = document.createElement('canvas')
      const gctx = gcanvas.getContext('2d')
      gcanvas.width = 28
      gcanvas.height = 28
      gcanvas.id = 'gcanvas' + String(this.renzokuCount + 1)
      gcanvas.style = 'margin: 2px; outline: black 1px solid;'
      var pixels = this.changeGrayscale(this.ctx28.getImageData(0, 0, this.canvas28.width, this.canvas28.height))
      gctx.putImageData(pixels, 0, 0)
      // gctx.drawImage(this.canvas28, 0, 0) // ColorになるのでGrayScaleに変換
      this.canvascont.appendChild(gcanvas)
      this.renzokuCount++
      this.renzokuTimer = setTimeout(this.getRenzokuCanvas, this.renSpinval * 1000)
    },
    cancelImg () {
      this.wsDisconnect()
      this.$store.dispatch('dispModalChg', {
        s_in: this.m_in,
        s_img: this.m_img
      })
    },
    changeGrayscale (pixels) {
      for (var y = 0; y < pixels.height; y++) {
        for (var x = 0; x < pixels.width; x++) {
          var i = (y * 4) * pixels.width + x * 4
          var rgb = parseInt((pixels.data[i] + pixels.data[i + 1] + pixels.data[i + 2]) / 3, 10)
          pixels.data[i] = rgb
          pixels.data[i + 1] = rgb
          pixels.data[i + 2] = rgb
          pixels.data[i + 3] = 255
        }
      }
      return pixels
    }
  },
  created () {
    this.m_in = this.setModals.modalin // Getterはdata()やcomputed()では使えないのでCreate時に代入
    this.m_img = this.setModals.modalimg // Getterはdata()やcomputed()では使えないのでCreate時に代入
    // console.log('modalKit:' + this.m_in + ':' + this.m_img)
  },
  mounted () { // Mount後でないとDOMが取得できない
    this.canvas = document.getElementById('draw_canvas')
    this.ctx = this.canvas.getContext('2d')
    this.imageData = this.ctx.createImageData(this.width, 1)
    this.canvas28 = document.getElementById('draw_canvas28')
    this.ctx28 = this.canvas28.getContext('2d')
    this.canvascont = document.getElementById('canvas_cont') // v-ifだと取得できないのでv-showで非表示
  }
}
</script>

<style scoped>
.modal-contentmax{
  z-index:101;
  width:95%;
  padding: 5px;
  border: 0;
  background:#eee;
  border-radius: 10px;
}
.modalLightGray {
  background: #eee;
}
.modal-pad1 {
  padding: 10px 0 10px 0;
}
.modal-pad2 {
  padding: 10px 0 10px 30px;
}
.img_container {
  position: relative;
  align-content: baseline;
}
.canvas28div {
  position: absolute;
  width: 28px;
  height: 28px;
  bottom: 0;
  margin: 0 0 0 10px;
  border: 0px;
  background: #fff;
}
.canvas28 {
  border: 0px;
  background: #000;
}
.aicanvas-word {
  position: absolute;
  margin: 0 0 0 -17px;
  top: -23px;
  right: -4px;
  font-size: 70%;
  line-height: 100%;
}
.img-cls {
  width: 356px;
  height: 288px;
  border: 0;
  background: #000;
}
.dispmes {
  font: outline;
  color: red;
}
.margintop {
  margin: 10px 0 0 0;
}
.btnwidth {
  width: 80px;
}
.btngwidth {
  width: 440px; /* 3button 370px*/
  padding: 0 70px 0 0;
  margin: 0 AUTO;
}
.renCheck {
  position: absolute;
  text-align: center;
  width: 123px;
  top: -13px;
  left: 115px
}
.verysFont {
  font-size: 80%;
}
.getRenzokuCls {
  position: absolute;
  text-align: center;
  width: 123px;
  top: 0px;
  left: 240px
}
div.container, div.col {
  max-width: 97%;
  margin: 0;
  padding: 0;
}
.canvas-cont-cls {
  width : -webkit-calc((100vw * 0.95) - 500px) ;
  width : calc((100vw * 0.95) - 500px) ;
  height: 288px;
  max-height: 300px;
  border: 1px solid #666666;
  background-color:#ddd;
  padding: 0;
  margin: 0 0 0 5px;
  overflow: auto;
}
.canvas-cont-word {
  z-index:1001;
  position: absolute;
  top: -20px;
  left : -webkit-calc(((100vw * 0.95) - 500px - 200px) / 2);
  left : calc(((100vw * 0.95) - 500px - 200px) / 2);
}
</style>



// WEBPACK FOOTER //
// src/components/InModalKit.vue